<main>
  <loading-overlay [isLoading]="isLoading > 0"></loading-overlay>
  <header>
    <div class="headline">
      <h1>
        {{
          requisition
            ? ('Yarn_Requisitions_Title' | translateWF: 'Yarn Requisitions') + ': ' + requisition.requisitionNumber
            : ('Yarn_Requisitions_New' | translateWF: 'New Requisition')
        }}
      </h1>
      <csl-dropdown [formControl]="status" [enumObject]="statusEnumObject" [enumValueOptions]="roleStatusOptions" [disabled]="!canEdit()" />
    </div>
    <div class="buttons">
      <p-button *ngIf="requisition?.id" class="ml-auto" label="Download Report" icon="pi pi-download" [outlined]="true" (click)="downloadRequisition()"></p-button>
      <span class="separator" *ngIf="requisition?.id"></span>
      <p-button *ngIf="canEdit() || showSaveButton" [label]="'Common_Save' | translateWF: 'Save'" (click)="save()" />
      <p-button [label]="'Common_Cancel' | translateWF: 'Cancel'" variant="outlined" (click)="cancel()" />
    </div>
  </header>

  <div class="content">
    @let showLocation = (canChangeLocation && isProcessingStatus) || !!currentFromLocationCode;
    <div class="grid-12">
      @if (showLocation) {
        <div class="span-5">
          <div class="row-between-center">
            @if (canChangeLocation && isProcessingStatus) {
              <div class="form-box">
                <label>{{ 'Yarn_Requisitions_Details_Source_Location' | translateWF: 'Source Location' }}</label>
                <p-select
                  [formControl]="locationSource"
                  [options]="locationSourceOptions"
                  optionLabel="label"
                  optionValue="value"
                  placeholder="{{ 'Yarn_Requisitions_Details_Select_Source' | translateWF: 'Select Source Location' }}"
                  styleClass="w-full"
                />
                <small class="text-gray-500">
                  {{
                    'Yarn_Requisitions_Details_Location_Change_Info'
                      | translateWF
                        : 'You can change the source location
              until the inventory transaction is saved'
                  }}
                </small>
              </div>
            } @else if (currentFromLocationCode) {
              <div class="col-sm">
                <div class="row-sm-start-center">
                  <p-tag severity="info" icon="pi pi-map-marker">
                    <span class="font-semibold">{{ 'Yarn_Requisitions_Details_From' | translateWF: 'From' }}:</span>
                    {{ currentFromLocationLabel }}
                  </p-tag>
                </div>
                @if (locationChangeLockedMessage) {
                  <p-message severity="warn" [text]="locationChangeLockedMessage" styleClass="text-sm" />
                }
              </div>
            }
          </div>
        </div>
      }
      <p-panel header="Notes" [ngClass]="showLocation ? 'span-7' : 'span-12'">
        <csl-standard-notes [userLite]="userLite!" [notes]="notes" (viewMore)="onViewMore()" (noteAdded)="onAddNote()" [viewOnly]="!canEdit()" />
      </p-panel>
    </div>

    <div class="row-between-center">
      <p-selectButton [formControl]="dataView" [options]="dataOptions" optionLabel="label" optionValue="value" />
      <app-qr-scanner-modal *ngIf="canEdit() && dataView.value === 'warehouse'" (isScannedCode)="onQrCodeScanned($event)" />
    </div>

    @if (dataView.value === 'knitting') {
      <form [formGroup]="requisitionsDetailsForm">
        <div class="col">
          <p-card>
            <div class="row items-end">
              <div class="form-box span-4">
                <label>{{ 'Yarn_Requisitions_Details_Knitting_Order' | translateWF: 'Knitting Order' }}</label>
                @if (!requisition?.id) {
                  <p-autocomplete
                    dropdownIcon="pi pi-search"
                    [placeholder]="'Yarn_Requisitions_Details_Search_Knitting' | translateWF: 'Search Knitting Order'"
                    class="w-full"
                    optionLabel="knittingOrderNumber"
                    #knittingOrderSearchRef="cslServerSearch"
                    [cslServerSearch]="fetchKnittingOrders"
                    [suggestions]="knittingOrderSearchRef.results()"
                    [dropdown]="true"
                    [formControl]="knittingOrder"
                    (onSelect)="onSelectKnittingOrderToUse($event)"
                    [ngClass]="{
                      'ng-invalid ng-dirty': requisitionsDetailsFormSubmitted && requisitionsDetailsForm.controls['initiator'].invalid,
                    }"
                  />
                } @else {
                  <input type="text" [value]="knittingOrder.value.knittingOrderNumber" pInputText disabled />
                }
              </div>
              <!-- @if (!requisitionsDetailsForm.controls['initiator'].value) { -->
              <div class="span-6" style="height: fit-content">
                <p-message severity="secondary"> <i class="pi pi-arrow-left"></i> {{ 'Yarn_Requisitions_Details_Select_Order' | translateWF: 'Select Knitting Order' }} </p-message>
              </div>
              <!-- } -->
            </div>
          </p-card>
          @if (requisitionsDetailsForm.controls['initiator'].value) {
            <div class="col">
              @for (group of groupedEntries; track $index) {
                <p-panel header="({{ group.itemCode }}) {{ getFabricByCode(group.itemCode!)?.longDescription }}" [toggleable]="true">
                  <ng-template pTemplate="icons">
                    @if (isGroupEntryValid(group)) {
                      <p-tag
                        pTooltip="{{ 'Yarn_Requisitions_Represent_Entry_Set_In_Knitting_Order' | translateWF: 'Represents Entry Set In Knitting Order' }}"
                        tooltipPosition="top"
                        class="ml-[1rem]"
                        >{{ getGroupVariantCode(group) }}</p-tag
                      >
                    } @else {
                      <p-tag severity="danger" pTooltip="{{ 'Yarn_Requisitions_Missing_Entry' | translateWF: 'Missing Entry' }}" tooltipPosition="top" class="ml-[1rem]">
                        {{ 'Yarn_Requisitions_No_Provider_Lot_Number' | translateWF: 'No Provider Lot Number' }}
                      </p-tag>
                    }
                  </ng-template>
                  <div class="col-xs">
                    <p-card>
                      <div class="grid-auto-4">
                        <div class="form-box">
                          <label>{{ 'Yarn_Requisitions_Details_Planned_Quantity' | translateWF: 'Planned Quantity' }}</label>
                          <input type="text" [disabled]="true" pInputText class="w-full" [value]="addCommasAndDecimal(group.plannedQuantity.value!)" />
                        </div>
                        @if (isGroupEntryValid(group)) {
                          <div class="form-box">
                            <label>{{ 'Yarn_Requisitions_Details_Fabric_Quantity' | translateWF: 'Fabric Quantity' }}</label>
                            @if (showInventoryTransactionsOnly || readonlyKnittingSection) {
                              <input type="text" class="w-full p-filled" [value]="addCommasAndDecimal(group.totalQuantity.value!)" pInputText disabled />
                            } @else {
                              <p-inputnumber
                                styleClass="w-full"
                                mode="decimal"
                                minFractionDigits="2"
                                maxFractionDigits="2"
                                #FabricTotalQuantityInput
                                [formControl]="group.totalQuantity"
                                (onInput)="calcRequiredItems(FabricTotalQuantityInput.value ?? 0, $index)"
                                [ngClass]="{
                                  'ng-invalid ng-dirty': requisitionsDetailsFormSubmitted && group.totalQuantity.invalid,
                                }"
                              />
                            }
                          </div>
                        }
                      </div>
                    </p-card>
                    <p-card data-variant="compact">
                      <p-table [value]="group.entries.controls" selectionMode="single" class="table__sm cs-datatable-overflow-visible">
                        <ng-template #header>
                          <tr class="dark__header">
                            <th>{{ 'Yarn_Requisitions_Details_Yarn_Name' | translateWF: 'Yarn Name' }}</th>
                            <th [style]="{ width: '100px' }">{{ 'Yarn_Requisitions_Details_Percentage' | translateWF: 'Percentage' }}</th>
                            <th>{{ 'Common_Quantity' | translateWF: 'Quantity' }}</th>
                            <th>{{ 'Common_Manufacturer' | translateWF: 'Manufacturer' }}</th>
                            <th>{{ 'Common_Manufacturer_Lot_Number' | translateWF: 'Manufacturer Lot Number' }}</th>
                          </tr>
                        </ng-template>
                        <ng-template #body let-entryFormGroup let-i="rowIndex">
                          <tr class="cursor-pointer" [formGroup]="entryFormGroup">
                            <td>
                              ({{ entryFormGroup.value.itemMaster.itemCode }})
                              {{ localHelperService.getLocalizedValue(entryFormGroup.value.itemMaster.itemDisplayName) }}
                            </td>
                            <td>{{ getYarnUsePercentage(group, entryFormGroup.value.itemCode) }}%</td>
                            <td>
                              <input
                                type="text"
                                class="w-full p-filled"
                                [value]="addCommasAndDecimal(entryFormGroup.get('requiredQuantityInUnitOfMeasure')?.value)"
                                pInputText
                                disabled
                              />
                            </td>
                            <td>
                              <p>({{ entryFormGroup.value.provider?.code }}) {{ entryFormGroup.value.provider?.name }}</p>
                            </td>
                            <td>
                              <p>{{ entryFormGroup.value.providerLotNumber }}</p>
                            </td>
                          </tr>
                        </ng-template>
                      </p-table>
                    </p-card>
                  </div>
                </p-panel>
              }
            </div>
          }
        </div>
      </form>
    } @else {
      @if (calcRequiredItemsTotal().length > 0) {
        <p-panel header="Required Items">
          <p-card data-variant="compact">
            <p-table [value]="calcRequiredItemsTotal()" selectionMode="single" styleClass="cs-datatable-overflow-visible">
              <ng-template #header>
                <tr>
                  <th>{{ 'Yarn_Requisitions_Details_Yarn_Name' | translate }}</th>
                  <th>{{ 'Yarn_Requisitions_Details_Required' | translate }}</th>
                  <th>{{ 'Yarn_Requisitions_Details_Loaded' | translate }}</th>
                </tr>
              </ng-template>
              <ng-template #body let-item>
                <tr>
                  <td>({{ item.itemMaster?.itemCode }}) {{ localHelperService.getLocalizedValue(item?.itemMaster?.itemDisplayName) }}</td>
                  <td>
                    {{ item.totalQuantity | number: '1.2-2' }}
                    <span class="text-gray-500 ml-1">
                      {{ unitOfMeasures[item?.itemMaster?.unitOfMeasure] || item?.itemMaster?.unitOfMeasure }}
                    </span>
                  </td>
                  <td>
                    <p-tag [severity]="item.loadedQuantity > 0 ? 'success' : 'warn'" [value]="addCommasAndDecimal(item.loadedQuantity)" />
                  </td>
                </tr>
              </ng-template>
            </p-table>
          </p-card>
        </p-panel>
      } @else {
        <p-message severity="secondary">{{ 'Yarn_Requisitions_Details_No_Items' | translate }}</p-message>
      }

      <p-panel [header]="'Yarn_Requisitions_Details_Inventory_Transactions' | translateWF: 'Inventory Transactions'">
        @if (editRequisition && !showRequisitionInProgressError) {
          @if (calcRequiredItemsTotal().length > 0) {
            @for (inventoryTransaction of inventoryTransactions; track $index) {
              <app-inventory-transaction
                [canEdit]="canEdit()"
                type="requisition-details"
                [readonly]="!canEditInventoryTransactions"
                [inventoryTransaction]="inventoryTransaction"
                [inventoryTransactionNeededElements]="inventoryTransactionNeededElements()"
                (updateInventoryTransaction)="updateInventoryTransactionNeededElement($event)"
              ></app-inventory-transaction>
            }
          }
        } @else if (showRequisitionInProgressError) {
          <p>
            {{
              'Yarn_Requisitions_Details_Requisition_Must_Be_In_Progress'
                | translateWF
                  : 'To start loading, requisition
        must be set to "In Process"'
            }}
          </p>
        } @else if (!editRequisition) {
          <p>
            {{
              'Yarn_Requisitions_Details_Requisition_Must_Be_In_Progress'
                | translateWF
                  : 'To start loading, requisition
        must be set to "In Process"'
            }}
          </p>
        }
      </p-panel>
    }
    @for (item of uniqueScanned; track $index) {
      <p-tag>{{ item }}</p-tag>
    }
  </div>
</main>
